(function(){
  'use strict';

  /* ---------- HERO SLIDER ---------- */
  function initHero(root){
    if(!root || root.__cg) return; root.__cg = true;
    var slides = root.querySelectorAll('.cg-hero__slide');
    var dots = root.querySelectorAll('.cg-hero__dot');
    var cur = root.querySelector('[data-cg-current]');
    var total = slides.length, idx = 0, timer = null;
    var speed = parseInt(root.getAttribute('data-speed') || '6', 10) * 1000;
    var auto = root.getAttribute('data-autoplay') === 'true' && total > 1;
    root.style.setProperty('--cg-speed', (speed/1000) + 's');

    function go(n){
      if(!total) return;
      idx = (n + total) % total;
      slides.forEach(function(s,i){ s.classList.toggle('is-active', i === idx); s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
      dots.forEach(function(d,i){
        d.classList.remove('is-active');
        d.classList.toggle('is-done', i < idx);
        if(i === idx){ void d.offsetWidth; if(auto) d.classList.add('is-active'); else d.classList.add('is-done'); }
      });
      root.classList.toggle('is-dark', slides[idx].classList.contains('cg-hero__slide--dark'));
      if(cur) cur.textContent = (idx < 9 ? '0' : '') + (idx + 1);
      restart();
    }
    function restart(){ clearTimeout(timer); if(auto && !root.classList.contains('is-paused')) timer = setTimeout(function(){ go(idx + 1); }, speed); }

    var prev = root.querySelector('[data-cg-prev]'), next = root.querySelector('[data-cg-next]');
    if(prev) prev.addEventListener('click', function(){ go(idx - 1); });
    if(next) next.addEventListener('click', function(){ go(idx + 1); });
    dots.forEach(function(d,i){ d.addEventListener('click', function(){ go(i); }); });

    root.addEventListener('mouseenter', function(){ root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function(){ root.classList.remove('is-paused'); restart(); });

    var sx = 0, sy = 0;
    root.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, {passive:true});
    root.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
    }, {passive:true});
    document.addEventListener('keydown', function(e){
      if(!root.matches(':hover')) return;
      if(e.key === 'ArrowLeft') go(idx - 1);
      if(e.key === 'ArrowRight') go(idx + 1);
    });

    root.__go = go;
    go(0);
  }

  /* ---------- RAIL (category / product carousels) ---------- */
  function initRail(wrap){
    if(!wrap || wrap.__cg) return; wrap.__cg = true;
    var rail = wrap.querySelector('.cg-rail');
    if(!rail) return;
    var prev = wrap.querySelector('[data-cg-prev]'), next = wrap.querySelector('[data-cg-next]');
    var bar = wrap.querySelector('.cg-progress span');

    function step(){ var c = rail.children[0]; if(!c) return rail.clientWidth; var g = parseFloat(getComputedStyle(rail).columnGap) || 0; return c.getBoundingClientRect().width + g; }
    function update(){
      var max = rail.scrollWidth - rail.clientWidth;
      if(prev) prev.disabled = rail.scrollLeft <= 4;
      if(next) next.disabled = rail.scrollLeft >= max - 4;
      if(bar){
        var ratio = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
        bar.style.width = Math.max(ratio * 100, 8) + '%';
        var p = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (1/Math.max(ratio,0.0001) - 1) * 100) + '%)';
        bar.parentNode.style.visibility = max > 4 ? 'visible' : 'hidden';
      }
    }
    if(prev) prev.addEventListener('click', function(){ rail.scrollBy({left:-step(), behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ rail.scrollBy({left:step(), behavior:'smooth'}); });
    rail.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);

    /* mouse drag */
    var down = false, startX = 0, startL = 0, moved = false;
    rail.addEventListener('mousedown', function(e){ down = true; moved = false; startX = e.pageX; startL = rail.scrollLeft; e.preventDefault(); });
    window.addEventListener('mousemove', function(e){
      if(!down) return; var dx = e.pageX - startX;
      if(Math.abs(dx) > 5){ moved = true; rail.classList.add('is-dragging'); }
      rail.scrollLeft = startL - dx;
    });
    window.addEventListener('mouseup', function(){
      if(!down) return; down = false;
      if(moved){
        rail.classList.remove('is-dragging');
        var s = step(); rail.scrollTo({left: Math.round(rail.scrollLeft / s) * s, behavior:'smooth'});
      }
    });

    /* autoplay */
    var ap = parseInt(wrap.getAttribute('data-autoplay') || '0', 10);
    if(ap > 0){
      var t = setInterval(function(){
        if(wrap.matches(':hover') || document.hidden) return;
        var max = rail.scrollWidth - rail.clientWidth;
        if(rail.scrollLeft >= max - 4) rail.scrollTo({left:0, behavior:'smooth'});
        else rail.scrollBy({left:step(), behavior:'smooth'});
      }, ap * 1000);
      wrap.__cgTimer = t;
    }
    update();
    setTimeout(update, 400);
  }

  /* ---------- TABS ---------- */
  function initTabs(root){
    if(!root || root.__cgTabs) return; root.__cgTabs = true;
    var tabs = root.querySelectorAll('.cg-tab'), panels = root.querySelectorAll('.cg-panel');
    tabs.forEach(function(t,i){
      t.addEventListener('click', function(){
        tabs.forEach(function(x,j){ x.classList.toggle('is-active', i === j); x.setAttribute('aria-selected', i === j); });
        panels.forEach(function(p,j){ p.classList.toggle('is-active', i === j); });
        var w = panels[i] && panels[i].querySelector('[data-cg-rail]');
        if(w){ w.__cg = false; initRail(w); }
      });
    });
  }

  /* ---------- ACCORDION ---------- */
  function initAcc(root){
    if(!root || root.__cgAcc) return; root.__cgAcc = true;
    root.querySelectorAll('.cg-acc__q').forEach(function(q){
      q.addEventListener('click', function(){
        var item = q.closest('.cg-acc__item');
        var open = item.classList.contains('is-open');
        root.querySelectorAll('.cg-acc__item').forEach(function(i){ i.classList.remove('is-open'); i.querySelector('.cg-acc__q').setAttribute('aria-expanded','false'); });
        if(!open){ item.classList.add('is-open'); q.setAttribute('aria-expanded','true'); }
      });
    });
  }

  /* ---------- REVEAL ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, {threshold:.12, rootMargin:'0px 0px -40px 0px'}) : null;
  function initReveal(scope){
    (scope || document).querySelectorAll('.cg-reveal:not(.is-in)').forEach(function(el){ if(io) io.observe(el); else el.classList.add('is-in'); });
  }

  /* ---------- PARALLAX ---------- */
  var parallax = [];
  function initParallax(scope){
    (scope || document).querySelectorAll('[data-cg-parallax]').forEach(function(el){ if(parallax.indexOf(el) < 0) parallax.push(el); });
  }
  var ticking = false;
  function onScroll(){
    if(ticking) return; ticking = true;
    requestAnimationFrame(function(){
      var vh = window.innerHeight;
      if(window.innerWidth < 901){ parallax.forEach(function(el){ el.style.transform=''; }); ticking=false; return; }
      parallax.forEach(function(el){
        var r = el.parentNode.getBoundingClientRect();
        if(r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height/2 - vh/2) / (vh + r.height);
        el.style.transform = 'translate3d(0,' + (p * -14) + '%,0)';
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, {passive:true});

  /* ---------- HEADER OFFSET ---------- */
  function headerOffset(){
    var b = document.body; if(!b) return;
    if(/template-index/.test(b.className)) return;
    var main = document.getElementById('main'); var first = main && main.firstElementChild;
    var hdr = document.getElementById('site-header'); if(!hdr || !first) return;
    var bottom = 0;
    [hdr, hdr.querySelector('.box__banner')].forEach(function(el){ if(el){ var r = el.getBoundingClientRect(); bottom = Math.max(bottom, r.bottom + window.pageYOffset); } });
    var pos = getComputedStyle(hdr).position;
    if(pos !== 'absolute' && pos !== 'fixed') return;
    b.classList.remove('cg-offset');
    var top = first.getBoundingClientRect().top + window.pageYOffset;
    if(top < bottom - 4){ document.documentElement.style.setProperty('--cg-hdr', Math.round(bottom) + 'px'); b.classList.add('cg-offset'); }
  }
  window.addEventListener('load', headerOffset);
  window.addEventListener('load', function(){ try{ if(window.jQuery){ jQuery('.box__product-gallery').each(function(){ var f=jQuery(this).data('flickity'); if(f){ f.resize(); } }); } }catch(e){} });
  var cgLastW = window.innerWidth; window.addEventListener('resize', function(){ if(window.innerWidth !== cgLastW){ cgLastW = window.innerWidth; headerOffset(); } });
  document.addEventListener('DOMContentLoaded', headerOffset);

  /* ---------- DRAWER ---------- */
  function moveDrawer(){ var d=document.getElementById('cg-drawer'); if(d && d.parentNode!==document.body) document.body.appendChild(d); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', moveDrawer); else moveDrawer();
  document.addEventListener('click', function(e){
    var o = e.target.closest && e.target.closest('[data-cg-open]');
    var c = e.target.closest && e.target.closest('[data-cg-close]');
    var d = document.getElementById('cg-drawer'); if(!d) return;
    if(o){ e.preventDefault(); d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); o.setAttribute('aria-expanded','true'); document.documentElement.classList.add('cg-lock'); }
    if(c){ d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('cg-lock'); var b=document.querySelector('[data-cg-open]'); if(b) b.setAttribute('aria-expanded','false'); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ var d=document.getElementById('cg-drawer'); if(d && d.classList.contains('is-open')) d.querySelector('[data-cg-close]').click(); } });

  /* ---------- FOOTER ACCORDION ON PHONES ---------- */
  function footAcc(){ if(window.innerWidth < 901){ document.querySelectorAll('.cg-foot__col[open]').forEach(function(d){ d.removeAttribute('open'); }); } }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', footAcc); else footAcc();

  /* ---------- SMOOTH IMAGE FADE IN ---------- */
  var FADE = '.cg-card__media img, .cg-cat__img img, .cg-step__img img, .cg-story__img img, .cg-mega__img img, .template-collection .box--product-image img';
  function markImg(img){ if(img.__cgf) return; img.__cgf = true; var done = function(){ img.classList.add('cg-in'); }; if(img.complete && img.naturalWidth > 0) done(); else { img.addEventListener('load', done); img.addEventListener('error', done); setTimeout(done, 4000); } }
  function fadeImgs(scope){ (scope || document).querySelectorAll(FADE).forEach(markImg); }
  document.documentElement.classList.add('cg-js');
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ fadeImgs(); }); else fadeImgs();
  window.addEventListener('load', function(){ fadeImgs(); });
  if('MutationObserver' in window){ new MutationObserver(function(){ fadeImgs(); }).observe(document.documentElement, {childList:true, subtree:true}); }

  /* ---------- TOP PROGRESS BAR ON PAGE CHANGE ---------- */
  function bar(){ var b = document.getElementById('cg-progress'); if(!b){ b = document.createElement('div'); b.id = 'cg-progress'; document.body.appendChild(b); } return b; }
  document.addEventListener('click', function(e){
    if(e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]'); if(!a || a.target === '_blank' || a.hasAttribute('download')) return;
    var u; try{ u = new URL(a.href, location.href); }catch(err){ return; }
    if(u.origin !== location.origin || (u.pathname === location.pathname && u.hash)) return;
    if(/^(mailto|tel):/.test(a.getAttribute('href'))) return;
    var b = bar(); b.classList.remove('is-on'); void b.offsetWidth; b.classList.add('is-on');
  }, true);
  window.addEventListener('pageshow', function(){ var b = document.getElementById('cg-progress'); if(b) b.classList.remove('is-on'); });

  /* ---------- BOOT ---------- */
  function boot(scope){
    scope = scope || document;
    scope.querySelectorAll('[data-cg-hero]').forEach(initHero);
    scope.querySelectorAll('[data-cg-tabs]').forEach(initTabs);
    scope.querySelectorAll('.cg-panel.is-active [data-cg-rail], [data-cg-rail]:not(.cg-panel [data-cg-rail])').forEach(initRail);
    scope.querySelectorAll('[data-cg-acc]').forEach(initAcc);
    initReveal(scope);
    initParallax(scope);
    onScroll();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function(e){ boot(e.target); e.target.querySelectorAll('.cg-reveal').forEach(function(el){ el.classList.add('is-in'); }); });
  document.addEventListener('shopify:block:select', function(e){
    var slide = e.target.closest && e.target.closest('.cg-hero__slide');
    if(slide){ var hero = slide.closest('[data-cg-hero]'); var i = Array.prototype.indexOf.call(hero.querySelectorAll('.cg-hero__slide'), slide); if(hero.__go) hero.__go(i); hero.classList.add('is-paused'); }
  });
})();

/* mega toggle */
(function(){var item=document.querySelector('.cg-nav__item--mega');if(!item)return;var btn=item.querySelector('[data-cg-mega]'),link=item.querySelector('.cg-nav__link--shop');
function set(o){item.classList.toggle('is-open',o);item.classList.toggle('is-closed',!o&&item.matches(':hover'));if(btn)btn.setAttribute('aria-expanded',o?'true':'false')}
if(btn)btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();set(!item.classList.contains('is-open'))});
if(link)link.addEventListener('click',function(e){if(window.matchMedia('(hover:none)').matches&&!item.classList.contains('is-open')){e.preventDefault();e.stopImmediatePropagation();set(true)}},true);
item.addEventListener('mouseleave',function(){item.classList.remove('is-closed');set(false)});
document.addEventListener('click',function(e){if(!item.contains(e.target))set(false)});
document.addEventListener('keydown',function(e){if(e.key==='Escape')set(false)});})();

/* drawer category slider */
(function(){var t=document.querySelector('.cg-drawer__cats');if(!t)return;var b=document.querySelectorAll('[data-cg-dslide]');
function upd(){var m=t.scrollWidth-t.clientWidth-2;b.forEach(function(x){var d=+x.getAttribute('data-cg-dslide');x.disabled=d<0?t.scrollLeft<=2:t.scrollLeft>=m})}
b.forEach(function(x){x.addEventListener('click',function(){t.scrollBy({left:(+x.getAttribute('data-cg-dslide'))*t.clientWidth*0.75,behavior:'smooth'})})});
t.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);document.addEventListener('click',function(e){if(e.target.closest('[data-cg-open]'))setTimeout(upd,350)});upd();})();

/* lazy videos: load only when near the screen */
(function(){var vs=document.querySelectorAll('video[data-cg-lazyvideo]');if(!vs.length)return;
function go(v){v.querySelectorAll('source[data-src]').forEach(function(s){s.src=s.getAttribute('data-src');s.removeAttribute('data-src')});v.load();var p=v.play();if(p&&p.catch)p.catch(function(){})}
if(!('IntersectionObserver' in window)){vs.forEach(go);return}
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){go(e.target);io.unobserve(e.target)}})},{rootMargin:'300px 0px'});vs.forEach(function(v){io.observe(v)});})();
/* product gallery: warm up every slide after the page is ready so swiping is instant */
(function(){function warm(){var imgs=document.querySelectorAll('.product--section img.lazyload, .product-gallery img.lazyload, .gallery-item img.lazyload, .flickity-slider img.lazyload');imgs.forEach(function(i){if(window.lazySizes&&lazySizes.loader){lazySizes.loader.unveil(i)}else{var s=i.getAttribute('data-src');if(s)i.src=s}})}
function later(){(window.requestIdleCallback||function(f){setTimeout(f,600)})(warm)}
if(document.readyState==='complete')later();else window.addEventListener('load',later);})();

/* stop the theme from re-laying out the page when only the height changes (phone address bar while scrolling) */
(function(){function patch(){var M=window.CUBER&&window.CUBER.Main;if(!M||!M._resizeEverything||M._cgPatched)return!!(M&&M._cgPatched);var orig=M._resizeEverything,lw=-1,lh=-1;M._resizeEverything=function(){var h=document.getElementById('site-header');var hh=h?h.offsetHeight:0;if(window.innerWidth===lw&&hh===lh)return;lw=window.innerWidth;lh=hh;return orig.apply(this,arguments)};M._cgPatched=true;return true}
if(!patch()){var n=0,iv=setInterval(function(){if(patch()||++n>100)clearInterval(iv)},50)}})();
